import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { AuthService } from "../../services/auth.service";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { PoolService } from "src/app/services/pool.service";
import { ParamService } from "src/app/services/param.service";
import { Router, ActivatedRoute } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { WaitComponent } from "../wait/wait.component";
import { Observable, pipe } from "rxjs";
import moment from "moment";

import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";

export const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "LL",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

import { DatePipe } from "@angular/common";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  providers: [
    DatePipe,
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: ["l", "LL"],
        },
        display: {
          dateInput: "L",
          monthYearLabel: "M YYYY",
          dateA11yLabel: "LL",
          monthYearA11yLabel: "MMMM YYYY",
        },
      },
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  ],
})
export class LoginComponent implements OnInit {
  formSubmitAttempt: boolean = false;
  form!: FormGroup;
  license: boolean = false;
  vekil: boolean = false;
  vekilOnay: boolean = false;
  users: any = [];
  delegations: any = [];
  groupDelegations: any = [];
  usrlanguages: any = [];
  usrlanguages1: any = [];
  userpassword: string = "";
  imageData: any;
  loginCount = 0;
  userCopy = "";
  prmDomain = "";
  newYear = false;
  response: any = null;
  user: string = "";
  seciliDil$: Observable<any> | undefined;
  tumDiller: any[] | undefined;

  constructor(
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private router: Router,
    private route: ActivatedRoute,
    private PoolService: PoolService,
    private ParamService: ParamService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private AuthService: AuthService,
  ) {}

  myObservable(observer: any) {
    setTimeout(() => {
      observer.next("");
      observer.complete();
    }, 1000);
  }

  showWaitScreen(observable: Observable<Object>) {
    let dialogRef: MatDialogRef<WaitComponent> = this.dialog.open(
      WaitComponent,
      {
        panelClass: "transparent",
        disableClose: true,
      },
    );
    let subscription = observable.subscribe(
      (response: any) => {
        subscription.unsubscribe();
        console.log(response);
        dialogRef.close();
      },
      (error) => {
        subscription.unsubscribe();
        dialogRef.close();
      },
    );
  }

  onSubmit() {
    this.login();
    // if (this.form.valid) {
    //   this.getDelegations(undefined, this.form.value.username);
    //   if (this.userCopy == '') this.userCopy = this.form.value.username;
    // }
    // else
    //    this.login();
  }

  ngOnInit() {
    // let today = moment.utc(new Date());
    // if ((today.utc().date() === 31 || today.utc().date() === 30 || today.utc().date() === 29 ) && (today.utc().month() + 1 == 12)) this.newYear = true;
    // else if (today.utc().date() === 1 && (today.utc().month() + 1 == 1)) this.newYear = true;
    // else this.newYear = false;
    // let config = new MatSnackBarConfig();
    this.tumDiller = this.AuthService.getDillerListesi(); // Arayüzde listelemek içi
    this.seciliDil$ = this.AuthService.getAktifDil; // Aktif dili dinliyoruz
    this.AuthService.getAktifDil.subscribe((aktif) => {
      localStorage.setItem("language", JSON.stringify(aktif));
    });

    this.form = this.fb.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
      llanguage: [""],
      remember: [false],
      usertype: [""],
      companyame: [""],
      userinfo: [""],
      chkvekiluser: [false],
    });

    if (localStorage.getItem("remember")) {
      this.form.patchValue({
        username: JSON.parse(localStorage.getItem("domainusername")!),
        password: JSON.parse(localStorage.getItem("domainpassword")!),
        llanguage: JSON.parse(localStorage.getItem("language")!).id,
        remember: JSON.parse(localStorage.getItem("remember")!),
        chkVekilUser: false,
      });
    }

    //  this.form.patchValue({ llanguage: this.seciliDil$ });

    // let observable = new Observable<Object>(this.myObservable);
    // this.showWaitScreen(observable);
    // this.getLisansInfo();
    // this.getParameters();

    // if (this.router.url.split('?')[1] !==undefined) {
    //   this.route.queryParams
    //     .subscribe((params) => {

    //       this.PoolService.getSecureLogin(atob(params.username))
    //       .subscribe((res:any) => {
    //       // this.user = atob(params.username);
    //       sessionStorage.removeItem('userinfo');
    //       sessionStorage.removeItem('username');
    //       sessionStorage.removeItem('companyname');
    //       sessionStorage.removeItem('usertype');
    //       sessionStorage.setItem('userinfo', JSON.stringify(res["userinfo"]));
    //       sessionStorage.setItem('username', JSON.stringify(res["username"]));
    //       sessionStorage.setItem('companyname', JSON.stringify(res["companyname"]));
    //       sessionStorage.setItem('usertype', JSON.stringify(res["usertype"]));
    //       const obj = { username: res["username"] , companyname: res["companyname"], usertype: res["usertype"], userinfo: res["userinfo"], password: res["password"], remember: false };
    //       this.authService.login(obj);

    //       }, err => {
    //         console.log(err);
    //       });

    //     });

    // }
  }

  compareDiller(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }

  getLisansInfo() {
    this.PoolService.getPoolControlLisans().subscribe(
      (res) => {
        let response: any = [];
        response = res;
        this.license = <boolean>response.valid;

        if (!this.license) {
          this.router.navigate(["/admin"]);
        }
      },
      (err) => {
        console.log(err);
      },
    );
  }

  dilDegistir(id: number) {
    this.AuthService.setDil(id);
  }

  getUserPassword() {
    this.form.patchValue({
      password: this.delegations.filter(
        (item: any) => item.user == this.form.value.username,
      )[0].userpassword,
    });
    if (this.form.value.chkvekiluser && this.userCopy === "") this.login();
  }

  getDelegations(user?: string, vekil?: string) {
    // if (this.vekil)
    // {
    //   if (this.form.value.)

    // }

    let config = new MatSnackBarConfig();
    config.panelClass = ["message-position"];
    this.snackBar.open("İşlem yapılıyor. Lütfen Bekleyiniz...", "", config);

    this.delegations = [];
    this.PoolService.getDelegations(user, vekil).subscribe((res: any) => {
      Object.keys(res).forEach((key) => {
        this.delegations[key] = res[key];
      });

      this.groupDelegations = this.delegations
        .map((item: any) => item.user)
        .filter(
          (value: any, index: any, self: any) => self.indexOf(value) === index,
        );
      if (this.delegations.length > 0) {
        this.vekil = true;
        if (this.form.value.chkVekilUser && this.userCopy === "") {
          this.login();
          this.snackBar.dismiss();
        } else {
          if (this.userCopy === "") this.form.value.userName = this.userCopy;

          this.loginCount++;
          if (this.loginCount > 1) this.login();
          this.snackBar.dismiss();
        }
      } else {
        this.login();
        this.snackBar.dismiss();
      }
    });
  }

  HesapOnayla(e: any) {
    if (e.checked && this.form.value.username !== "")
      this.form.patchValue({ username: this.form.value.username });

    this.form.patchValue({ chkvekiluser: e.checked });
    console.log(this.form.value);
  }

  RememberMe(e: any) {
    if (e.checked) {
      localStorage.setItem("remember", JSON.stringify(e.checked));
      localStorage.setItem(
        "domainusername",
        JSON.stringify(this.form.value.username),
      );
      localStorage.setItem(
        "domainpassword",
        JSON.stringify(this.form.value.password),
      );
    } else {
      localStorage.removeItem("domainusername");
      localStorage.removeItem("domainpassword");
      localStorage.removeItem("remember");
    }
  }

  getLanguages() {
    this.ParamService.getLanguage().subscribe((res) => {
      this.usrlanguages = res;
    });
  }

  getUserLanguage() {
    this.ParamService.getLanguage().subscribe((res) => {
      this.usrlanguages1 = res;

      this.form.patchValue({ llanguage: this.usrlanguages1[0].id });
    });
  }

  postUserLanguage() {
    // this.PoolService.postLanguage(this.form.value.username, null, this.form.value.llanguage).subscribe(res => {
    //   // this.usrlanguages1 = res;
    //   // this.form.patchValue({ llanguage: this.usrlanguages1[0].id });
    // });
  }

  getParameters() {
    this.ParamService.getParameters().subscribe(
      (res: any) => {
        Object.keys(res).forEach((key) => {
          this.prmDomain = res[key].domain;
        });

        this.getLanguages();
        if (localStorage.getItem("remember")) {
          if (this.prmDomain !== null)
            this.form.patchValue({
              username: JSON.parse(localStorage.getItem("domainusername")!),
              password: JSON.parse(localStorage.getItem("domainpassword")!),
              llanguage: "",
              remember: JSON.parse(localStorage.getItem("remember")!),
              chkVekilUser: false,
            });
          else
            this.form.patchValue({
              username: JSON.parse(localStorage.getItem("domainusername")!),
              password: JSON.parse(localStorage.getItem("domainpassword")!),
              llanguage: "",
              remember: JSON.parse(localStorage.getItem("remember")!),
              chkVekilUser: false,
            });

          this.ParamService.getLanguage().subscribe((res) => {
            this.usrlanguages1 = res;
            this.form.patchValue({ llanguage: this.usrlanguages1[0].id });
          });
        } else
          // {
          //   this.form = this.fb.group({
          //     userName: ['', Validators.required],
          //     password: ['', Validators.required],
          //     llanguage: [''],
          //     remember: [false],
          //     userType: [''],
          //     firmName: [''],
          //     userInfo: [''],
          //     chkVekilUser: [false]
          //     // mnOpened: [false]
          //   });

          this.form.patchValue({ llanguage: 1 });

        // }

        // this.snackBar.dismiss();
      },
      (err) => {
        // this.snackBar.dismiss();
        console.log(err);
      },
    );
  }

  openSnackBar(message: string, seconds: number) {
    this.snackBar.open(message, "", {
      duration: seconds * 1000,
      verticalPosition: "top",
    });
  }

  isFieldInvalid(field: any) {
    return (
      (!this.form.get(field).valid && this.form.get(field).touched) ||
      (this.form.get(field).untouched && this.formSubmitAttempt)
    );
  }

  forgotPassword() {
    const cacheBuster = new Date().getTime();
    this.router.navigate(["/forgot"], {
      queryParams: {
        v: cacheBuster,
        mobile: "false",
      },
    });

    // if (this.form.value.userName === "") {
    //   this.openSnackBar("Kullanıcı adını giriniz.", 2);
    //   return;
    // }

    // debugger;
    // if (this.form.valid) {

    // const obj = { username: this.form.value.username };
    // this.PoolService.poolSendPassword(obj).subscribe(
    //   (res: any) => {
    //     console.log(res["responseDscr"]);
    //     this.openSnackBar(res["responseDscr"], 3);
    //   },
    //   (err) => {
    //     console.log(err);
    //     this.openSnackBar(err.message, 2);
    //   },
    // );

    // }
  }

  // loginCall(obj: any) {
  //   return this.AuthService.poolLogin(obj)
  //     .toPromise()
  //     .then((data) => {
  //       this.response = <any>data;
  //     });
  // }

  async login() {
    const obj = this.form.value;
    obj.domain = this.prmDomain;
    obj.domainusername = this.form.value.username;
    obj.domainpassword = this.form.value.password;
    // await this.loginCall(obj);
    this.AuthService.poolLogin(obj)
      .toPromise()
      .then((user: any) => {
        if (user.statusCode == 401) {
          let config = new MatSnackBarConfig();
          config.duration = 3000;
          config.horizontalPosition = "center";
          config.verticalPosition = "top";
          config.panelClass = ["message-position"];
          this.snackBar.open("Kullanıcı veya şifre hatalı.", "Kapat", config);
          return;
        }

        if (user.returnCode === "200") {
          if (user.password === "") {
            sessionStorage.setItem("username", JSON.stringify(obj.username));
            this.openSnackBar(
              "Şifreniz resetlenmiştir. Lütfen şifrenizi tekrar tanımlayın.",
              2,
            );
            this.router.navigate(["/repassword"]);
            return;
          }

          sessionStorage.setItem("userinfo", JSON.stringify(user.userinfo));
          sessionStorage.setItem("usertype", JSON.stringify(user.usertype));
          sessionStorage.setItem("userid", JSON.stringify(user.id));
          sessionStorage.setItem("username", JSON.stringify(user.username));
          sessionStorage.setItem("companyid", JSON.stringify(user.companyId));
          sessionStorage.setItem(
            "companyname",
            JSON.stringify(user.companyname),
          );
          sessionStorage.setItem("token", JSON.stringify(user.token));
          this.AuthService.setObserveable(user);
        }
      });

    // if (this.response && this.response.returnCode === "200") {

    //   obj.username = this.response.username;
    //   obj.password = this.response.password;
    //   obj.domain = this.prmDomain;
    //   this.AuthService.login(obj);
    // } else if (this.response.returnCode === "506") {
    //   // localStorage.removeItem('userName');
    //   localStorage.setItem("username", JSON.stringify(obj.username));
    //   this.openSnackBar(this.response.returnDscr, 3);
    //   this.router.navigate(["/repassword"]);
    // } else if (this.response.returnCode === "504") {
    //   this.openSnackBar(this.response.returnDscr, 3);
    // } else {
    //   this.openSnackBar(this.response.returnDscr, 3);
    // }
  }
}
